import React from "react";
import Movies from "./Movies";

const PracticeA9 = () => {
  return(
      <div>
        <h1>Practice</h1>
        <Movies/>
      </div>
  )
};

export default PracticeA9;

